import mixpanel from 'mixpanel-browser';
import { AbstractTracker, TrackEventParameters } from './AbstractTracker';
import { get } from 'lodash';

export class MixpanelModule extends AbstractTracker {
  settings = {};

  get isLoaded() {
    return get(mixpanel, '__loaded', false);
  }

  init(): void {
    mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN || '');
  }

  trackEvent = this.runIfLoaded(({ parameters, event }: TrackEventParameters): void => {
    mixpanel.track(event, parameters);
  });

  peopleSet = this.runIfLoaded((event: string, parameter: any): void => {
    mixpanel.people.set(event, parameter);
  });

  peopleSetOnce = this.runIfLoaded((event: string, parameter: any): void => {
    mixpanel.people.set_once(event, parameter);
  });

  identify = this.runIfLoaded((identifier: string): void => {
    mixpanel.identify(identifier);
  });

  register = this.runIfLoaded((parameters: object): void => {
    mixpanel.register(parameters);
  });

  runIfLoaded(callback: Function) {
    return (params: any) => {
      if (!this.isLoaded) return;
      callback(params);
    };
  }
}
